import { roomApi, PATIENT_ROOM_FEATURE_KEYS } from '../../services/room';

export const buildGetRoomForPatientArgs = (slug: string) => ({
  input: {
    slug,
    featureKeys: PATIENT_ROOM_FEATURE_KEYS,
  },
});

/**
 * Warms the RTK Query cache for getRoomForPatient. Safe to call from a route
 * loader; useGetRoomForPatientQuery with the same args subscribes without a
 * duplicate network request.
 */
export const prefetchRoomForPatient = async (slug: string): Promise<void> => {
  if (!slug) {
    return;
  }

  const { store } = await import('../../stores/redux');

  await store
    .dispatch(
      roomApi.endpoints.GetRoomForPatient.initiate(
        buildGetRoomForPatientArgs(slug),
      ),
    )
    .unwrap();
};
